import app from 'flarum/common/app';
import { extend, override } from 'flarum/common/extend';
import { getIPData } from '../helpers/IPDataHelper';
import Tooltip from 'flarum/common/components/Tooltip';
import Button from 'flarum/common/components/Button';
import { handleCopyIP } from '../helpers/ClipboardHelper';
/**
 * In-flight IP info requests, keyed by IP address.
 * Prevents duplicate API calls when multiple components request the same IP.
 */
const ipInfoRequests = new Map();
export default function extendIpAddress() {
  extend('flarum/common/components/IPAddress', 'viewItems', function (items) {
    // loadIpInfo is triggered by Intersection Observer when component enters viewport
    if (this.ipInfo && items.has('ip')) {
      items.remove('ip');
      const {
        description,
        threat,
        image
      } = getIPData(this.ipInfo);
      items.add('ipInfo', m("span", {
        className: "ip-info"
      }, image, m(Tooltip, {
        text: "".concat(description, " ").concat(threat ? "(".concat(threat, ")") : '')
      }, m("code", null, this.ip))), 100);
      items.add('copyButton', m(Tooltip, {
        text: app.translator.trans('fof-geoip.lib.copy_ip_label')
      }, m(Button, {
        icon: "fas fa-copy",
        className: "Button Button--icon Button--link",
        onclick: handleCopyIP(this.ip),
        "aria-label": app.translator.trans('fof-geoip.lib.copy_ip_label')
      })), 95);
      items.add('infoButton', m(Tooltip, {
        text: app.translator.trans('fof-geoip.lib.map_button_label')
      }, m(Button, {
        icon: "fas fa-info-circle",
        className: "Button Button--icon Button--link",
        onclick: e => {
          e.stopPropagation();
          app.modal.show(() => import(/* webpackChunkName: 'common/components/MapModal', webpackMode: 'lazy-once' */ '../components/MapModal'), {
            ipInfo: this.ipInfo,
            ipAddr: this.ip
          });
        },
        "aria-label": app.translator.trans('fof-geoip.lib.map_button_label')
      })), 90);
    }
  });
  override('flarum/common/components/IPAddress', 'view', function () {
    return m("span", {
      className: "IPAddress IPAddress--enhanced ip-container",
      oncreate: vnode => {
        if (this.ip.length === 0 || this.ipInfo) return;
        const observer = new IntersectionObserver(entries => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              this.loadIpInfo();
              observer.disconnect();
            }
          }
        }, {
          rootMargin: '100px'
        });
        observer.observe(vnode.dom);
        this._ipObserver = observer;
      },
      onremove: () => {
        if (this._ipObserver) {
          this._ipObserver.disconnect();
          this._ipObserver = null;
        }
      }
    }, this.viewItems().toArray());
  });
  extend('flarum/common/components/IPAddress', 'oninit', function () {
    var _app$store$getBy;
    // Populate synchronously if already in store (e.g. included with post response).
    this.ipInfo = (_app$store$getBy = app.store.getBy('ip_info', 'ip', this.ip)) != null ? _app$store$getBy : undefined;
    this.loadIpInfo = async function () {
      if (this.ip.length === 0) return;
      try {
        // Deduplicate: reuse in-flight request if another component already requested this IP
        let request = ipInfoRequests.get(this.ip);
        if (!request) {
          request = app.store.find('ip_info', encodeURIComponent(this.ip));
          ipInfoRequests.set(this.ip, request);
          request.finally(() => ipInfoRequests.delete(this.ip));
        }
        this.ipInfo = await request;
        m.redraw();
      } catch (error) {
        console.error('Failed to load IP info:', error);
      }
    };
  });
}
flarum.reg.add('fof-geoip', 'common/extenders/extendIpAddress', extendIpAddress);flarum.reg.addChunkModule('315', '90', 'fof-geoip', 'common/components/MapModal');
flarum.reg.addChunkModule('315', '90', 'fof-geoip', 'common/components/ZipCodeMap');flarum.reg.addChunkModule('315', '90', 'fof-geoip', 'common/components/MapModal');
flarum.reg.addChunkModule('315', '90', 'fof-geoip', 'common/components/ZipCodeMap');